import React, { useEffect, useRef } from "react"
import "./index.less"
import lottie from 'lottie-web'

const LoadingPage = () => {
  const lottieNode = useRef<any>(null)

  useEffect(() => {
    showLottie()
    return componentWillUnmount
  }, [])

  const componentWillUnmount = () => {
    lottie.destroy()
  }

  const showLottie = () => {
    lottie.destroy()
    import('./assets/loading.json').then((animationData) => {
      if (lottieNode.current) {
        lottie.loadAnimation({
          container: lottieNode.current,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: animationData
        });
      }
    })
  }

  return (
    <div className={'loadingPage'}>
      <div className={'loadingCont'} ref={item => { lottieNode.current = item }}></div>
    </div>
  )
}

export default LoadingPage